import Busca from './Busca';
import Tags from './Tags';
import TituloComFiltro from './TituloComFiltro';

export default { Busca, Tags, TituloComFiltro };
